module.exports = __webpack_public_path__ + "img/water03.62639398.png";